module.exports = __webpack_public_path__ + "img/e7a70fe09f416cb0ea00a1da408f6394.png";